import { RiFolderCloudLine } from "@onemind-services-llc/react-icons-ng/ri";
import { AiOutlineSolution } from "@onemind-services-llc/react-icons-ng/ai";
import {
  MdOutlineTimer,
  MdOutlineIntegrationInstructions,
} from "@onemind-services-llc/react-icons-ng/md";

export const ONEMIND_LAAS_CONSTANTS = {
  title: "Why Choose OneMind Cloud Services LaaS?",
  list: [
    {
      icon: RiFolderCloudLine,
      title: "Fully Managed Virtual Lab Environments",
      content:
        "Focus on your business while we handle the backend infrastructure, ensuring seamless operations.",
    },
    {
      icon: AiOutlineSolution,
      title: "Customizable Solutions",
      content:
        "Configure the lab environment according to your specific IT needs, offering flexibility and control.",
    },
    {
      icon: MdOutlineIntegrationInstructions,
      title: "Seamless Integration",
      content:
        "Works smoothly with your existing IT ecosystem, making adoption easy and efficient.",
    },
    {
      icon: MdOutlineTimer,
      title: "24/7 Support",
      content:
        "Dedicated assistance to ensure a hassle-free experience with round-the-clock expert support.",
    },
  ],
  conclusion:
    "With OneMind Cloud Services, you can accelerate innovation, reduce risks, and optimize IT operations effortlessly. Whether you're a business looking for scalable network testing solutions or an engineer wanting to practice complex configurations, our Lab-as-a-Service ensures a smooth and efficient experience. ",
};
